import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { useForm } from 'react-hook-form'
import AssetBookingListsForm from './AssetBookingListsForm'
import AssetBookingListsTable from './AssetBookingListsTable'
import { searchAssetBookingLists } from '../../redux/actions/assetBookingLists'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import notification from '../../utils/notification'
import { doneLoading, startLoading } from '../../utils/loading'
import { downloadDurableArticlesFile } from '../../redux/actions/accountingExpenses'
import { previewFile } from '../../utils/fileUtil'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'

export default function AssetBookingListsWidgets(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState(props.schema.result || [])

  const onSearch = async (request, pagenumber = 1, pagesize = 5) => {
    console.log('onSearch', pagenumber, pagesize)

    setIsLoading(true)
    startLoading()

    try {
      var response = await searchAssetBookingLists(request, pagenumber, pagesize)

      if (response.model) {
        setDataTable(response?.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleViewFiles = async (fileName, filePath) => {
    console.log('handleViewFiles ', filePath)

    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadDurableArticlesFile(filePath)

      // downloadFile(file, fileName)
      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={' '} bordered>
        {isLoading && <OverlayLoader />}

        {/* <AssetBookingListsForm
          schema={formSchema.searchForm}
          onSearch={onSearch}
          loading={isLoading}
        /> */}

        <AssetBookingListsTable
          searchForm={formSchema.searchForm}
          schema={dataTable}
          loading={isLoading}
          onViewFiles={handleViewFiles}
          onReload={onSearch}
          onSearch={onSearch}
        />
      </Panel>
    </>
  )
}
